export const removeFromCart = (lineItemId, quantity, isBundle) => {
  /**
   * It removeFrom cart for pay load
   */
  const actions = [
    {
      action: isBundle ? "removebundle" : "removeLineItem",
      lineItemId: lineItemId,
      quantity: quantity,
    },
  ]
  return actions
}

export const setRemoveCartPayload = (items = []) => {
  /**
   * It removeFrom cart for payload
   */
  const actions = []
  items.forEach(item => {
    actions.push({
      action: item.isComboSku ? "removebundle" : "removeLineItem",
      lineItemId: item.id,
      quantity: item.quantity,
    })
  })
  return actions
}
